<div style="display: flex; justify-content: center; align-items: center; height: 100vh; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
    <form nz-form [formGroup]="loginForm" class="login-form" (ngSubmit)="submitLoginForm()">
        <h2>Welcome Back</h2>
        <p style="text-align: center; color: #8c8c8c; margin-bottom: 32px; font-size: 14px;">Sign in to continue to your account</p>
      
      <!-- Username/Email/Cell No field -->
      <nz-form-item>
        <nz-form-control nzErrorTip="Enter username, email or cell number">
          <nz-input-group nzPrefixIcon="user" [nzAddOnAfter]="isCellNumber && showPasswordField ? otpButton : undefined">
            <input type="text" nz-input formControlName="username" placeholder="Username / Email / Cell No" />
          </nz-input-group>
          <ng-template #otpButton>
            <button 
              type="button"
              nz-button 
              nzSize="small"
              [nzType]="'default'" 
              [disabled]="!canRequestOtp"
              [nzLoading]="isRequestingOtp"
              (click)="sendOtp()"
              [@slideIn]>
              @if (otpCountdown === 0) {
                <span>Send OTP</span>
              }
              @if (otpCountdown > 0) {
                <span>{{ otpCountdown }}s</span>
              }
            </button>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <!-- Password field (animated, shown when username is filled and no OTP requested) -->
      @if (showPasswordField && !otpRequested) {
        <nz-form-item [@slideIn]>
          <nz-form-control nzErrorTip="Enter password">
            <nz-input-group nzPrefixIcon="lock">
              <input type="password" nz-input formControlName="password" placeholder="Password" />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
      }

      <!-- OTP field (shown when OTP was requested) -->
      @if (otpRequested) {
        <nz-form-item [@slideIn]>
          <nz-form-control nzErrorTip="Enter OTP">
            <nz-input-group nzPrefixIcon="lock">
              <input type="text" nz-input formControlName="otp" placeholder="Enter OTP" maxlength="6" />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
      }

      @if (showPasswordField) {
        <div nz-row class="login-form-margin" [@slideIn]>
          @if (!otpRequested) {
            <div nz-col [nzSpan]="24">
              <a class="login-form-forgot">Forgot password</a>
            </div>
          }
        </div>
        
        <button 
          nz-button 
          class="login-form-button login-form-margin" 
          [nzType]="'primary'"
          [disabled]="!showPasswordField"
          [@slideIn]>
          Log in
        </button>
      }
    </form>
    
</div>